import { render, staticRenderFns } from "./pd-convert-your-kit.vue?vue&type=template&id=683005fe&scoped=true&"
import script from "./pd-convert-your-kit.vue?vue&type=script&lang=js&"
export * from "./pd-convert-your-kit.vue?vue&type=script&lang=js&"
import style0 from "./pd-convert-your-kit.vue?vue&type=style&index=0&id=683005fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683005fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductImg: require('/opt/build/repo/storefront/components/legacy/global/product-img.vue').default,BaseToggle: require('/opt/build/repo/storefront/components/atoms/Input/BaseToggle.vue').default})
